import { IPromise, IServiceProvider } from "angular";
import { vsComponentName as definitionDetailMachineComponentName } from "./views/definitions/detail/machines";
import { vsComponentName as definitionDetailMachineEditComponentName } from "./views/definitions/detail/machines/edit";
import { Record } from "../records/server/crud";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../records/server/serverUtility";

export const vsServiceName = "progressiveModuleConfigurationService";
export const vsProviderName = `${vsServiceName}Provider`;

type ProgressiveDefinitionMachinesFetcher = (
  serverUtility: ServerUtility,
  progressiveDefinition: Record
) => IPromise<Record[]>;

export class ProgressiveModuleConfigurationServiceProvider
  implements IServiceProvider
{
  progressiveMachinesComponentName: string =
    definitionDetailMachineComponentName;
  progressiveMachinesEditMachineComponentName: string =
    definitionDetailMachineEditComponentName;
  progressiveDefinitionMachinesFetcher: ProgressiveDefinitionMachinesFetcher = (
    serverUtility,
    progressiveDefinition
  ) =>
    serverUtility.fetchAllWrapped<Record>({
      url: `/api/machines/progressives/ProgressiveDefinition/${progressiveDefinition.Id}/Machines`,
      query: {
        Fields: "Id,MachineConfigurationId",
      },
    });

  $get = [
    ServerUtilityName,
    (serverUtility: ServerUtility) =>
      new ProgressiveModuleConfigurationService(
        this.progressiveMachinesComponentName,
        this.progressiveMachinesEditMachineComponentName,
        this.progressiveDefinitionMachinesFetcher,
        serverUtility
      ),
  ];
}

export class ProgressiveModuleConfigurationService {
  constructor(
    readonly detailMachineComponentName: string,
    readonly detailMachineEditComponentName: string,
    private readonly machineFetcher: ProgressiveDefinitionMachinesFetcher,
    private readonly serverUtility: ServerUtility
  ) {}

  getProgressiveDefinitionMachines(progressiveDefinition: Record) {
    return this.machineFetcher(this.serverUtility, progressiveDefinition);
  }
}
